import { QueryHookOptions, useQuery } from '@apollo/client';

import { USER_BY_ID_QUERY_FOR_UNITADMIN_CALENDAR } from './queries';
import { User } from './types';

export const useUserByIdForUnitAdminCalendar = (id: number | null, options?: QueryHookOptions) =>
  useQuery<{ user: User }>(USER_BY_ID_QUERY_FOR_UNITADMIN_CALENDAR, { ...options, variables: { id } });
